@import "/src/variables/tokens";
@import "/src/variables/color";
@import "/src/variables/layout";
@import "/src/variables/border-radius";
@import "/src/variables/shadow";

:where(.button) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 0;
  border: none;
  background: transparent;
  color: $body-text-1;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.button:disabled {
  cursor: default;
}

.sm {
  width: $control-size-icon-sm;
  height: $control-size-icon-sm;
}

.md {
  width: $control-size-icon;
  height: $control-size-icon;
}

.surface {
  border-radius: $border-radius-circle;
  background: $zv-control--White;
  box-shadow: $shadow-sm;
  color: $zv-icon--icon-color;
}

.scrim {
  border-radius: $border-radius-circle;
  background: $opacity-neutral-darkest-60;
  box-shadow: $shadow-sm;
  color: $White;
}

.tertiary {
  border: $border-width solid $border-dark;
  border-radius: $border-radius-circle;
  background: $zv-control--White;
  box-shadow: $shadow-new-lg;
  color: $zv-icon--icon-color;
}
